import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

import { ContainerIndicative, ContainerIndicators, Image, TextThemes } from "./styles";
import useScreenSize from "../../Hooks/useScreenSize";

const BannerImages = () => {
  const { width } = useScreenSize();
  const mobile = [
    {
      id: 1,
      image: "/bannerImgs/mobileInterestTheme1.png",
    },
    {
      id: 2,
      image: "/bannerImgs/mobileInterestTheme2.png",
    },
    {
      id: 3,
      image: "/bannerImgs/mobileInterestTheme3.png",
    },
    {
      id: 4,
      image: "/bannerImgs/mobileInterestTheme4.png",
    },
    {
      id: 5,
      image: "/bannerImgs/mobileInterestTheme5.png",
    },
    {
      id: 6,
      image: "/bannerImgs/mobileInterestTheme6.png",
    },
    {
      id: 7,
      image: "/bannerImgs/mobileInterestTheme7.png",
    },
    {
      id: 8,
      image: "/bannerImgs/mobileInterestTheme8.png",
    },
  ];
  const web = [
    {
      id: 1,
      image: "/bannerImgs/interestThemes1.png",
    },
    {
      id: 2,
      image: "/bannerImgs/interestThemes2.png",
    },
    {
      id: 3,
      image: "/bannerImgs/interestThemes3.png",
    },
  ];

  return (
    // <ContainerBanner>
    <Swiper
      navigation={true}
      modules={[Navigation]}
      style={{ boxSizing: "border-box", marginTop: 10, marginBottom: 30, width: "100%" }}
    >
      {width > 900
        ? web.map((item) => (
            <SwiperSlide key={item.id}>
              <ContainerIndicative>
                <Image src={item.image} alt="banner" />
                <TextThemes>
                  <ContainerIndicators>{item.id}</ContainerIndicators>
                </TextThemes>
              </ContainerIndicative>
            </SwiperSlide>
          ))
        : mobile.map((item) => (
            <SwiperSlide key={item.id}>
              <ContainerIndicative>
                <textThemes>
                  <ContainerIndicators>{item.id}</ContainerIndicators>
                </textThemes>
                <Image src={item.image} alt="banner" />
              </ContainerIndicative>
            </SwiperSlide>
          ))}
    </Swiper>
    // </ContainerBanner>
  );
};

export default BannerImages;
